<template>
  <div class="woo-home">
    <div class="woo-top-banner">
      <div class="woo-top-banner-left">
       <img
        :src="require('@/assets/logo.png')"
        class="woo-header-logo"
        alt="The Woobles"
        contain
        height="30"
      />
      <h2>Step-by-step guides</h2>
      <span>
        Pick your kit. Then type in the password that's on the back of the card in
        your kit.
      </span>
      </div>
      <div class="woo-top-banner-right"/>
    </div>
    <label id="search-label" for="search" style="display: none;">Search</label>
    <input
      aria-labelledby="search-label"
      name="search"
      v-model="search"
      class="woo-search-input"
      placeholder="Find your Wooble..."
      @keydown="this.keyDownSearch"
      ref="search">
    <div class="woo-tutorials">
      <v-row>
        <v-col
          v-for="n in tutorials"
          :key="n.id"
          cols="6"
          xs="6"
          sm="4"
          md="3"
          lg="3"
          style="position: relative;"
        >
          <div
            class="woo-tutorials-tag" 
            :style="{
              'background-color': getTagColor(n),
              'color': getTagTextColor(n),
            }"
            v-if="n.tag">{{n.tag}}
          </div>
          <router-link
            class="woo-tutorials-link"
            :to="`/tutorial/${n.slug_url}`"
          >
            <v-img
              :src="n.kit_picker_image_url"
              :lazy-src="n.kit_picker_image_url"
              aspect-ratio="1"
              class="woo-tutorials-item"
            />
            <div class="woo-tutorials-title">{{ n.display_name }}</div>
            <div class="woo-tutorials-level">{{ n.difficulty }}</div>
          </router-link>
        </v-col>
      </v-row>
    </div>
    <page-footer/>
  </div>
</template>

<script>
import HelperMethods from '@/helpers/HelperMethods';
import PageFooter from '@/components/PageFooter.vue';
import { debounce } from 'lodash/fp';

export default {
  name: 'HomeView',
  components: { PageFooter },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    tutorials() {
      return this.$store.state.tutorials.filter(t => {
        return t.include_in_kit_picker && HelperMethods.matchText({
          text: t.display_name,
          query: this.search,
        });
      });
    },
  },
  methods: {
    keyDownSearch: debounce(500, function() {
      HelperMethods.postGoogleEvent({
        event: 'kit_picker_search',
        category: 'Kit Picker Search',
        label: this.search,
      });
    }),
    getTagTextColor(tutorial) {
      if (tutorial.tag === 'Collab') {
        return '#11A1C8'  
      } else {
        return '#FFF' 
      }
    },
    getTagColor(tutorial) {
      if (tutorial.tag_color) {
        return `#${tutorial.tag_color}`;
      } else if (tutorial.tag === 'Limited Edition') {
        return '#11A1C8'  
      } else if (tutorial.tag === 'Collab') {
        return '#FFF' 
      }
    }
  },
  mounted() {
    if (this.$route.query?.dev) {
      this.$store.commit('devModeOn', true);
    }
    
    if (!HelperMethods.isMobile()) {
      this.$refs.search.focus();
    }
  }
};
</script>
<style lang="scss" scoped>
.woo-search-input {
  margin-top: 1.5rem;
}

// Mobile
@media screen and (max-width: 768px) {
  .woo-search-input {
    margin-left: 20px;
    width: calc(100% - 40px) !important;
  }

  .woo-home {
    max-width: 100%;
    padding: 0px;
  }

  .woo-top-banner {
    border-radius: 0px;
    flex-direction: column;
  }

  .woo-top-banner-left {
    padding: 30px 30px 0px 30px;
    text-align: center;
  }

  .woo-top-banner-right {
    display: flex;
    background-position: 50% -35px;
    height: 150px;
    width: calc(100% + 40px);
    margin-left: -20px;
  }

  .woo-tutorials {
    padding: 0px 20px;
  }
}

// Desktop
@media screen and (min-width: 768px){
  .woo-home {
    max-width: 872px;
    padding: 20px;
  }

  .woo-top-banner {
    border-radius: 10px;
  }

  .woo-top-banner-left {
    padding: 60px 0px 60px 40px;
  }

  .woo-top-banner-right {
    flex: 0 0 500px;
    width: 372px;
  }

  .woo-top-banner-right-img {
    height: 100%;
    width: 100%;
  }
}

.woo {

  &-top-banner {
    background-color: #93C564;
    display: flex;
    overflow: hidden;

    &-left {
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    &-right {
      background-image: url('~@/assets/guides-header.jpg');
      background-size: cover;
      background-position: center;
    }
  }

  &-tutorials {
    position: relative;
    margin: 1.5rem auto;

    &-tag {
      font-size: 10px;
      padding: 3px 7px;
      color: white;
      text-transform: uppercase;
      font-weight: 900;
      line-height: 15px;
      letter-spacing: 0.04em;
      border-radius: 13px; 
      position: absolute;
      left: 20px;
      top: 20px;
      z-index: 10;
    }
    &-link {
      width: 100%;
      height: 100%;
    }
    &-item {
      border-radius: 0.5rem;
      background-color: #ddd;
    }
    &-title {
      color: black;
      font-size: 18px;
      font-weight: 900;
      padding-top: 8px;
    }
    &-level {
      color: black;
      font-size: 16px;
    }
  }
  &-home {
    text-align: left;
    margin: auto;
  }
}
</style>
